import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", {
        email,
        origin_url: window.location.origin,
      });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha ao solicitar");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 p-6">
      <Card className="w-full max-w-md p-8 rounded-2xl border-stone-200">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <img src="/logo.png" alt="Ultra" className="h-8 w-8 rounded-md" />
          <span className="font-display text-lg font-extrabold">Ultra</span>
        </Link>

        {sent ? (
          <div className="text-center py-6" data-testid="forgot-success">
            <MailCheck className="h-10 w-10 text-emerald-700 mx-auto mb-3" />
            <h1 className="font-display text-2xl font-extrabold tracking-tight">Verifique seu e-mail</h1>
            <p className="font-body text-sm text-stone-500 mt-2">
              Se existir uma conta para <strong>{email}</strong>, enviamos um link de
              redefinição válido por 1 hora.
            </p>
            <Link to="/login">
              <Button variant="outline" className="mt-6">
                <ArrowLeft className="h-4 w-4 mr-2" /> Voltar ao login
              </Button>
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-extrabold tracking-tight">Recuperar senha</h1>
            <p className="font-body text-sm text-stone-500 mt-2">
              Informe seu e-mail e enviaremos um link para criar uma nova senha.
            </p>
            <form onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="forgot-form">
              <div>
                <Label htmlFor="email" className="font-body text-sm">E-mail</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="voce@empresa.com"
                  required
                  data-testid="forgot-email"
                  className="mt-1.5 bg-white"
                />
              </div>
              <Button
                type="submit"
                disabled={submitting}
                data-testid="forgot-submit"
                className="w-full bg-emerald-800 hover:bg-emerald-900 text-white h-11 font-body"
              >
                {submitting ? "Enviando..." : "Enviar link de recuperação"}
              </Button>
            </form>
            <p className="mt-6 text-center text-sm text-stone-500 font-body">
              Lembrou a senha?{" "}
              <Link to="/login" className="text-emerald-800 font-semibold hover:underline">
                Entrar
              </Link>
            </p>
          </>
        )}
      </Card>
    </div>
  );
}
